export const YOUTUBE_VIDEO_ID = 'ZEB3EcDwsb0'
export const YOUTUBE_VIDEO_TITLE = 'Used vs Verified'
export const YOUTUBE_VIDEO_THUMBNAIL_URL =
  'https://i3.ytimg.com/vi/ZEB3EcDwsb0/hqdefault.jpg'

// The following states are defined in the YouTube iframe API.
// See: https://developers.google.com/youtube/iframe_api_reference#Playback_status
export const YOUTUBE_VIDEO_ENDED_STATE = 0
export const YOUTUBE_VIDEO_UNSTARTED_STATE = -1

// I used youtube-nocookie.com as the origin, to reduce the tracking.
// The YouTube video is used globally and is being replaced by the self-hosted
// <video> (MarketingVideo.vue) because YouTube isn't fully GDPR-compliant.
// Until that rollout completes we still prefer youtube-nocookie.com to reduce
// the tracking done by YouTube for privacy reasons.
export const YOUTUBE_VIDEO_ORIGIN = 'https://www.youtube-nocookie.com'
